import client from './client';

export const outboundWebhooksApi = {
  // ==================== ENDPOINTS ====================
  async list(scopeType, scopeId) {
    const { data } = await client.get('/api/outbound-webhooks', {
      params: { scopeType, scopeId },
    });
    return data;
  },

  async create(endpointData) {
    const { data } = await client.post('/api/outbound-webhooks', endpointData);
    return data;
  },

  async update(id, updates) {
    const { data } = await client.patch(`/api/outbound-webhooks/${id}`, updates);
    return data;
  },

  async remove(id) {
    const { data } = await client.delete(`/api/outbound-webhooks/${id}`);
    return data;
  },

  // ==================== ACTIONS ====================
  async test(id) {
    const { data } = await client.post(`/api/outbound-webhooks/${id}/test`);
    return data;
  },

  async reEnable(id) {
    const { data } = await client.post(`/api/outbound-webhooks/${id}/re-enable`);
    return data;
  },

  // ==================== DELIVERIES ====================
  async getDeliveries(id, params = {}) {
    const { data } = await client.get(`/api/outbound-webhooks/${id}/deliveries`, { params });
    return data;
  },
};
